<router-outlet></router-outlet>
<app-loader image="/spinner.gif"></app-loader>